const Design = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 100.75 100.75"
  >
    <path 
      d="M93.486,22.069L77.931,6.514c-0.586-0.586-1.535-0.586-2.121,0L48.135,34.188L31.428,17.75
	c-0.013-0.013-0.03-0.022-0.044-0.034c-0.055-0.05-0.114-0.095-0.177-0.137c-0.03-0.02-0.058-0.042-0.089-0.06
	c-0.074-0.042-0.153-0.075-0.235-0.105c-0.021-0.007-0.039-0.02-0.06-0.027L8.195,10.317c-0.53-0.165-1.113-0.023-1.508,0.371
	c-0.395,0.395-0.538,0.976-0.371,1.508l7.071,22.627c0.043,0.137,0.109,0.263,0.188,0.381c0.025,0.038,0.055,0.069,0.083,0.104
	c0.037,0.046,0.067,0.096,0.109,0.137l16.69,16.421L6.514,75.81c-0.586,0.586-0.586,1.535,0,2.121l15.556,15.557
	c0.281,0.281,0.663,0.439,1.061,0.439s0.779-0.158,1.061-0.439l24.19-24.19l19.572,19.021c0.25,0.241,0.564,0.358,0.885,0.393
	c2.27,2.105,5.198,3.27,8.312,3.27c3.272,0,6.349-1.274,8.662-3.588c4.713-4.713,4.766-12.338,0.177-17.128
	c-0.073-0.249-0.203-0.479-0.393-0.662L65.968,51.711l27.519-27.52C94.072,23.604,94.072,22.655,93.486,22.069z M28.521,19.812
	l-1.121,3.81l-5.226,1.537c-0.489,0.144-0.872,0.526-1.016,1.016L19.622,31.4l-3.811,1.121l-5.777-18.486L28.521,19.812z
	 M23.13,90.306L9.695,76.87l5.652-5.652l6.717,6.717c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439
	c0.586-0.586,0.586-1.535,0-2.121l-6.717-6.717l5.504-5.504l6.717,6.717c0.293,0.293,0.677,0.439,1.061,0.439
	s0.768-0.146,1.061-0.439c0.586-0.586,0.586-1.535,0-2.121l-6.717-6.717l7.509-7.509l13.627,13.244L23.13,90.306z M83.689,86.272
	c-3.357,3.355-8.668,3.584-12.296,0.695l12.992-12.992C87.274,77.604,87.045,82.917,83.689,86.272z M68.983,85.136L33.541,50.691
	L17.689,35.095l3.565-1.048c0.489-0.144,0.872-0.526,1.016-1.016l1.537-5.225l5.226-1.537c0.489-0.144,0.872-0.526,1.016-1.016
	l1.062-3.609l31.646,31.136l19.659,18.924L68.983,85.136z M63.817,49.619L50.273,36.292l7.699-7.699l6.717,6.717
	c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439c0.586-0.585,0.586-1.536,0-2.121l-6.717-6.717l6.254-6.254
	l6.717,6.717c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439c0.586-0.585,0.586-1.536,0-2.121l-6.717-6.717
	l8.402-8.402L90.305,23.13L63.817,49.619z"
    />
  </svg>
);

export default Design;


